import { render, staticRenderFns } from "./Calification.vue?vue&type=template&id=02c115ec"
import script from "./Calification.vue?vue&type=script&lang=js"
export * from "./Calification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports